import styled from 'styled-components';

import { PolicyDescription } from '../../../common/policyStyles';

export const PolicyDescriptionError = styled(PolicyDescription)`
  color: ${(props) => (props.isError ? '#ff4d44' : '#333')};
`;
